module.exports = "/_next/static/images/4-226282ce.gif";